export const breakpoints = {
  xs: '0px',
  sm: '600px',
  md: '900px',
  lg: '1280px',
  xl: '1920px',
};